import { render } from "./ProjectStatsGraph.vue?vue&type=template&id=da15fd7e&scoped=true"
import script from "./ProjectStatsGraph.vue?vue&type=script&lang=js"
export * from "./ProjectStatsGraph.vue?vue&type=script&lang=js"

import "./ProjectStatsGraph.vue?vue&type=style&index=0&id=da15fd7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da15fd7e"]])

export default __exports__